'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getSize;

var _sizes = require('../../constants/sizes');

function getSize(size, type, screenSize) {

    // default size is Medium
    var value = '15';

    if (size === _sizes.Sizes.sm) {
        value = '10';
    }

    if (size === _sizes.Sizes.md) {
        value = '20';
    }

    if (size === _sizes.Sizes.xl) {
        value = '40';
    }

    if (type === "image") {
        switch (screenSize) {
            case "xs":
            case "sm":
                value = "80";
                break;
            case "md":
            case "lg":
            case "xl":
                value = "130";
                break;
        }
    }

    return { height: value, width: value };
}